import type { ProductShop } from '@@partner:types:app'
import type { GQL_ID, CommonFilter } from '@@partner:types:graphql'

import { gql, useQuery } from '@apollo/client'

export interface ProductAvailableShops {
  shops: ProductShop[]
}

export interface ProductAvailableShopsVariables {
  filter?: CommonFilter
}

export const GQL_QUERY_AVAILABLE_SHOPS = gql`
  query($filter: CommonFilterInput) {
    shops: availableShops(filter: $filter) {
      id
      name
      address
    }
  }
`

export const useAvailableShopsQuery = (
  filter?: CommonFilter,
  skip: boolean = false
) => {
  return useQuery<ProductAvailableShops, ProductAvailableShopsVariables>(
    GQL_QUERY_AVAILABLE_SHOPS,
    {
      variables: {
        filter
      },
      skip
    }
  )
}
